import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery, getApiBaseUrl } from 'modules/api/utils';

export type RttStatus = 'STARTING' | 'ACTIVE' | 'UPDATING' | 'STOPPED' | 'ERROR';

export type RttResponse = { channel: string; status: RttStatus; agentId?: string; language?: string };

export type RttRequest = { channel: string; eventId: number };

export type RttLanguage = { code: string; displayName: string };

export type RttLanguagesResponse = { languages: RttLanguage[] };

export type SetRttLanguageRequest = { channel: string; eventId: number; language: string };

export const agoraApi = createApi({
  reducerPath: 'agoraApi',
  baseQuery: axiosBaseQuery({ baseURL: getApiBaseUrl('v1') }),
  endpoints: (builder) => ({
    startRtt: builder.mutation<RttResponse, RttRequest>({
      query: (data) => ({ url: '/agora/rtt/start', method: 'POST', data }),
    }),
    stopRtt: builder.mutation<RttResponse, RttRequest>({
      query: (data) => ({ url: '/agora/rtt/stop', method: 'POST', data }),
    }),
    getRttLanguages: builder.query<RttLanguagesResponse, void>({
      query: () => ({ url: '/agora/rtt/languages', method: 'GET' }),
    }),
    setRttLanguage: builder.mutation<RttResponse, SetRttLanguageRequest>({
      query: (data) => ({ url: '/agora/rtt/language', method: 'POST', data }),
    }),
  }),
});

export const { useStartRttMutation, useStopRttMutation, useGetRttLanguagesQuery, useSetRttLanguageMutation } = agoraApi;
